<template>
  <router-view></router-view>
</template>

<script setup></script>

<style>
/* 1. 清除浏览器默认的 8px 边距，防止页面边缘留白 */
html,
body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial,
    sans-serif;
  background-color: #f5f7fa; /* 匹配你 SeaClaw 的底色 */
}

#app {
  width: 100%;
  height: 100%;
}
</style>
